module.exports = __webpack_public_path__ + "img/touchpoint-fort.20ef6c87.svg";